export const BULK_RESHIP_START = 'BULK_RESHIP_START';
export const bulkReshipStart = ({ fulfillmentPlanIds, trackReshipShipmentSuccess, trackReshipShipmentError }) => ({
  type: BULK_RESHIP_START,
  fulfillmentPlanIds,
  trackReshipShipmentSuccess,
  trackReshipShipmentError,
});
